import axios from 'axios';

const API = axios.create({baseURL: 'https://chatapi.danimtech.com/'});

export const signup = (newUser) => API.post('/users/signup', newUser);
export const signin = (User) => API.post('/users/signin', User);